module.exports = __webpack_public_path__ + "img/aboutItem.f0e7cd0b.png";